export default __webpack_public_path__ + "static/media/JAYEEN-BIN-ALAM-ROOTDEVS.03863aa3.webp";